import { Box, Heading } from '@machobear/design-system'
import { BadgeIcon } from '@/elements'
import { ImportedBadge } from './imported-badge'
import { useListingData } from '../../context/listing-data'

export const ListingAddress = () => {
  const { listingAddress, listingVerified, isImported } = useListingData()

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="flexStart"
      gap="xxsmall"
    >
      <Heading level="4">{listingAddress}</Heading>
      {listingVerified && (
        <BadgeIcon id="verified_listing" data-testid="verified_badge" width={24} height={24} />
      )}
      {isImported && <ImportedBadge />}
    </Box>
  )
}
